<div class="card-container">
  <ng-content select="[start]"></ng-content>

  <div class="content-container" [style.margin-left]="leftContentMargin">
    <div class="content" [style.maxWidth]="contentWidth">
      @if (name) {
        <div class="name" [style.font-size]="nameFontSize">
          {{ name }}{{ suffix ? suffix : "" }}
        </div>
      }
      @if (description) {
        <div
          class="description"
          [style.font-size]="descriptionFontSize"
          [style.max-width]="descriptionMaxWidth"
        >
          {{ description }}
        </div>
      }
      @for (item of descriptionItems; track item) {
        <div
          class="description"
          [style.font-size]="descriptionFontSize"
          [style.max-width]="descriptionMaxWidth"
        >
          {{ item.content }}
        </div>
      }
    </div>

    <ng-content select="[end]"></ng-content>
  </div>
</div>
